// Hooks/useCourseDetails.js
import { useEffect, useState, useCallback } from "react";
import { fetchCourseDetails } from "../../Services/CourseListService";

const useCourseDetails = (courseId, refreshKey = 0) => {
  const [course, setCourse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!courseId) return;

    try {
      setLoading(true);
      console.log("Fetching course data, refreshKey:", refreshKey);
      const data = await fetchCourseDetails(courseId);
      console.log("Fetched course data:", data);
      setCourse(data);
      setError(null);
    } catch (err) {
      console.error("Error in useCourseDetails hook:", err);
      setError(err.message || "Failed to fetch course");
    } finally {
      setLoading(false);
    }
  }, [courseId, refreshKey]); // Add refreshKey here

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { course, loading, error, refetch: fetchData };
};

export default useCourseDetails;